<template>
  <div class="roting">
    <div class="roting-title">
      {{ data.userRouter.name }}
    </div>
    <div
      :class="item.path == $route.path ? 'active' : ''"
      v-for="(item, index) in data.userRouter.children.filter(v => !v.hidden)"
      :key="index"
      class="roting-item"
      @click="routerClick(item, index)"
    >
      <el-icon class="iceoc"><icon-menu /></el-icon>
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script setup>
import { Document, Menu as IconMenu, Location, Setting } from "@element-plus/icons-vue";
import { onMounted, ref, defineProps, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
import { useStore } from "@/stores/modules/router.js";
const data = useStore();
const { getNum } = data;
const state = reactive({
  num: 0,
});
const props = defineProps({});

onMounted(() => {
  state.num = data.num;
});

const routerClick = (item, index) => {
  router.push(item.path);
  state.num = index;
  getNum(index);
};
</script>

<style lang="less" scoped>
.roting {
  width: 150px;
  height: 100%;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: #fff;
  margin-right: 15px;

  &-title {
    color: #999;
    padding: 20px;
    font-size: 14px;
  }
}

.roting-item {
  height: 35px;
  display: flex;
  align-items: center;
  width: 80%;
  border-radius: 3px;
  margin-left: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #494949;
  cursor: pointer;
}

.el-icon {
  font-size: 14px !important;
  margin-right: 5px;
  margin-left: 10px;
}

.roting-item:hover {
  background-color: #e5eeff !important;
  color: #266fed;
}

.active {
  background-color: #e5eeff !important;
  color: #266fed;
}
</style>
